import * as React from "react";
const SvgDropdownIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 6.5L8 11.5L13 6.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgDropdownIcon;
